import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuthStore } from '../store';

const C = {
  bg:'#0A0E1A',card:'#0D1526',surface:'#111827',
  accent:'#00D4AA',gold:'#F59E0B',border:'#1e2d45',
  text:'#E8EDF5',muted:'#6b7fa3',navy:'#003366',red:'#FF4F6A'
};

const PLANS = [
  { id:'influenceur', label:'Influenceur / Particulier', price:'5 000 FCFA/mois', desc:"Jusqu'à 10 000 abonnés" },
  { id:'pme',         label:'PME',                       price:'15 000 FCFA/mois', desc:'Abonnés illimités + analytics' },
  { id:'entreprise',  label:'Grande Entreprise',         price:'50 000 FCFA/mois', desc:'Support prioritaire + badge premium' },
];

const CATEGORIES = ['Média / Presse','Radio / TV','Religion / Église','Commerce / Boutique','Politique / Institution','Santé / Hôpital','Éducation / École','Divertissement','Autre'];

const PAYMENT_INFO = { orange_money:'699505253', mtn_momo:'679119530' };

export default function VerifiedChannelPage() {
  const navigate = useNavigate();
  const { token } = useAuthStore();
  const [step, setStep] = useState(1); // 1=plan, 2=infos, 3=paiement, 4=confirme
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    channel_id:'', plan:'pme', organisation_name:'', organisation_type:'',
    phone:'', payment_method:'orange_money', payment_reference:'',
    website_url:'', contact_phone:'', channel_category:''
  });
  const [requestData, setRequestData] = useState(null);

  useEffect(() => {
    // Charger les canaux de l'utilisateur
    fetch('/api/messages/channels/mine', { headers:{ Authorization:'Bearer ' + (localStorage.getItem('access_token') || token) } })
      .then(r=>r.json()).then(d=>{ if(d.success) setChannels(d.data||[]); });
  }, []);

  const inp = (field, val) => setForm(f=>({...f,[field]:val}));

  const submitRequest = async () => {
    if (!form.channel_id) return toast.error('Sélectionnez un canal');
    if (!form.organisation_name) return toast.error("Nom de l'organisation requis");
    if (!form.organisation_type) return toast.error("Type d\'organisation requis");
    if (!form.phone) return toast.error('Numéro de téléphone requis');
    setLoading(true);
    try {
      const res = await fetch('/api/messages/channels/verify/request', {
        method:'POST',
        headers:{ Authorization:'Bearer ' + (localStorage.getItem('access_token') || token), 'Content-Type':'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.success) {
        setRequestData(data);
        setStep(3);
      } else {
        toast.error(data.error || 'Erreur lors de la demande');
      }
    } catch(e) { toast.error('Erreur réseau'); }
    finally { setLoading(false); }
  };

  const selectedPlan = PLANS.find(p=>p.id===form.plan);

  return (
    <div style={{fontFamily:"sans-serif",background:C.bg,color:C.text,position:"fixed",inset:0,overflowY:"auto"}}>
      {/* HEADER */}
      <div style={{position:"sticky",top:0,zIndex:100,background:C.bg,borderBottom:`1px solid ${C.border}`,padding:"14px 20px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={()=>navigate(-1)} style={{background:"none",border:"none",color:C.accent,fontSize:24,cursor:"pointer"}}>&#8249;</button>
        <div>
          <span style={{fontSize:20,fontWeight:700,color:C.accent}}>PAY</span>
          <span style={{fontSize:20,fontWeight:700,color:C.text,position:"relative",left:-5}}>CHAT</span>
          <span style={{fontSize:12,color:C.muted,marginLeft:8}}>Canal Vérifié ✓</span>
        </div>
      </div>

      {/* PROGRESS */}
      <div style={{display:"flex",padding:"16px 20px",gap:8}}>
        {["Plan","Informations","Paiement","Confirmation"].map((s,i)=>(
          <div key={i} style={{flex:1,textAlign:"center"}}>
            <div style={{height:4,background:step>i?C.accent:C.border,borderRadius:2,marginBottom:4}}/>
            <div style={{fontSize:10,color:step>i?C.accent:C.muted}}>{s}</div>
          </div>
        ))}
      </div>

      <div style={{padding:"0 20px 40px"}}>

        {/* STEP 1 - CHOIX DU PLAN */}
        {step===1 && (
          <>
            <div style={{fontSize:22,fontWeight:700,marginBottom:6}}>Choisissez votre plan</div>
            <div style={{fontSize:13,color:C.muted,marginBottom:24}}>Le badge ✓ officialise votre canal PayChat</div>

            {/* Avantages */}
            <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{fontSize:14,fontWeight:700,color:C.accent,marginBottom:12}}>Ce que vous obtenez</div>
              {[
                "Badge ✓ vérifié visible sur votre canal",
                "Abonnés illimités (vs 1 000 gratuit)",
                "Tableau de bord analytics complet",
                "Boutons Site web & Contact",
                "Planification de messages",
                "Messages épinglés illimités",
                "Support prioritaire ZENVOI SARL",
              ].map((a,i)=>(
                <div key={i} style={{display:"flex",gap:10,marginBottom:8,alignItems:"center"}}>
                  <span style={{color:C.accent,fontSize:16}}>✓</span>
                  <span style={{fontSize:13,color:C.text}}>{a}</span>
                </div>
              ))}
            </div>

            {/* Plans */}
            {PLANS.map(p=>(
              <div key={p.id} onClick={()=>inp("plan",p.id)}
                style={{background:form.plan===p.id?C.navy:C.card,
                  border:`2px solid ${form.plan===p.id?C.accent:C.border}`,
                  borderRadius:14,padding:16,marginBottom:12,cursor:"pointer"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:15,fontWeight:700,color:form.plan===p.id?C.accent:C.text}}>{p.label}</div>
                    <div style={{fontSize:12,color:C.muted,marginTop:2}}>{p.desc}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:16,fontWeight:700,color:C.accent}}>{p.price}</div>
                    {form.plan===p.id && <div style={{fontSize:11,color:C.accent}}>✓ Sélectionné</div>}
                  </div>
                </div>
              </div>
            ))}

            <button onClick={()=>setStep(2)} style={{width:"100%",background:C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:"pointer",marginTop:8}}>
              Continuer →
            </button>
          </>
        )}

        {/* STEP 2 - INFORMATIONS */}
        {step===2 && (
          <>
            <div style={{fontSize:22,fontWeight:700,marginBottom:6}}>Informations</div>
            <div style={{fontSize:13,color:C.muted,marginBottom:24}}>Ces informations seront affichées sur votre canal</div>

            {/* Sélection canal */}
            <div style={{marginBottom:16}}>
              <div style={{fontSize:13,color:C.muted,marginBottom:6}}>Canal à vérifier *</div>
              <select value={form.channel_id} onChange={e=>inp("channel_id",e.target.value)}
                style={{width:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",color:C.text,fontSize:14}}>
                <option value="">Sélectionnez votre canal</option>
                {channels.map(c=>(
                  <option key={c.id} value={c.id}>{c.name} ({c.subscriber_count||0} abonnés)</option>
                ))}
              </select>
              {!channels.length && <div style={{fontSize:12,color:C.gold,marginTop:6}}>⚠️ Vous n'avez pas encore de canal. Créez-en un d'abord.</div>}
            </div>

            {[
              {label:"Nom de l'organisation *", field:"organisation_name", placeholder:"Ex: Radio Amplitude FM"},
              {label:"Téléphone de contact *", field:"phone", placeholder:"+237 6XX XXX XXX"},
              {label:"Site web (optionnel)", field:"website_url", placeholder:"https://..."},
            ].map(f=>(
              <div key={f.field} style={{marginBottom:16}}>
                <div style={{fontSize:13,color:C.muted,marginBottom:6}}>{f.label}</div>
                <input value={form[f.field]} onChange={e=>inp(f.field,e.target.value)}
                  placeholder={f.placeholder}
                  style={{width:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",color:C.text,fontSize:14,boxSizing:"border-box"}}/>
              </div>
            ))}

            <div style={{marginBottom:16}}>
              <div style={{fontSize:13,color:C.muted,marginBottom:6}}>Type d\'organisation *</div>
              <select value={form.organisation_type} onChange={e=>inp("organisation_type",e.target.value)}
                style={{width:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",color:C.text,fontSize:14}}>
                <option value="">Sélectionnez...</option>
                {CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div style={{display:"flex",gap:10,marginTop:8}}>
              <button onClick={()=>setStep(1)} style={{flex:1,background:"transparent",border:`1px solid ${C.border}`,borderRadius:12,padding:"14px",color:C.text,fontSize:14,cursor:"pointer"}}>← Retour</button>
              <button onClick={submitRequest} disabled={loading}
                style={{flex:2,background:loading?"#666":C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:loading?"not-allowed":"pointer"}}>
                {loading?"Envoi...":"Envoyer la demande →"}
              </button>
            </div>
          </>
        )}

        {/* STEP 3 - PAIEMENT */}
        {step===3 && requestData && (
          <>
            <div style={{fontSize:22,fontWeight:700,marginBottom:6}}>Effectuez le paiement</div>
            <div style={{fontSize:13,color:C.muted,marginBottom:24}}>Votre demande est enregistrée. Finalisez le paiement pour activer le badge.</div>

            {/* Référence */}
            <div style={{background:C.navy,border:`1px solid ${C.accent}`,borderRadius:14,padding:16,marginBottom:20,textAlign:"center"}}>
              <div style={{fontSize:12,color:C.muted,marginBottom:4}}>Votre référence de paiement</div>
              <div style={{fontSize:24,fontWeight:700,color:C.accent,letterSpacing:2}}>
                {requestData.payment_info?.reference}
              </div>
              <div style={{fontSize:12,color:C.muted,marginTop:4}}>Mentionnez cette référence lors du paiement</div>
            </div>

            {/* Montant */}
            <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <span style={{color:C.muted}}>Plan</span>
                <span style={{fontWeight:700}}>{selectedPlan?.label}</span>
              </div>
              <div style={{display:"flex",justifyContent:"space-between"}}>
                <span style={{color:C.muted}}>Montant à payer</span>
                <span style={{fontSize:20,fontWeight:700,color:C.accent}}>{requestData.payment_info?.montant?.toLocaleString()} FCFA</span>
              </div>
            </div>

            {/* Options paiement */}
            <div style={{fontSize:14,fontWeight:700,marginBottom:12}}>Choisissez votre mode de paiement :</div>

            {/* Orange Money */}
            <div style={{background:C.card,border:`2px solid #FF6B00`,borderRadius:14,padding:16,marginBottom:12}}>
              <div style={{fontSize:15,fontWeight:700,color:"#FF6B00",marginBottom:8}}>🟠 Orange Money</div>
              <div style={{fontSize:13,color:C.muted,marginBottom:4}}>Composez sur votre téléphone :</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:16,color:C.text,marginBottom:8}}>
                #150*1*1*{PAYMENT_INFO.orange_money}*{requestData.payment_info?.montant}#
              </div>
              <div style={{fontSize:12,color:C.muted}}>Numéro bénéficiaire : <strong style={{color:C.text}}>{PAYMENT_INFO.orange_money}</strong></div>
            </div>

            {/* MTN MoMo */}
            <div style={{background:C.card,border:`2px solid #FFCC00`,borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{fontSize:15,fontWeight:700,color:"#FFCC00",marginBottom:8}}>🟡 MTN MoMo</div>
              <div style={{fontSize:13,color:C.muted,marginBottom:4}}>Composez sur votre téléphone :</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:16,color:C.text,marginBottom:8}}>
                *126*1*1*{PAYMENT_INFO.mtn_momo}*{requestData.payment_info?.montant}#
              </div>
              <div style={{fontSize:12,color:C.muted}}>Numéro bénéficiaire : <strong style={{color:C.text}}>{PAYMENT_INFO.mtn_momo}</strong></div>
            </div>

            {/* Instructions */}
            <div style={{background:"#F59E0B11",border:"1px solid #F59E0B44",borderRadius:12,padding:14,marginBottom:20}}>
              <div style={{fontSize:13,fontWeight:700,color:C.gold,marginBottom:8}}>📋 Instructions</div>
              <div style={{fontSize:12,color:C.muted,lineHeight:1.7}}>
                1. Effectuez le paiement via Orange Money ou MTN MoMo<br/>
                2. Notez le numéro de transaction<br/>
                3. Envoyez un WhatsApp à <strong style={{color:C.text}}>+237 697 008 362</strong> avec :<br/>
                &nbsp;&nbsp;&nbsp;• Votre référence : <strong style={{color:C.accent}}>{requestData.payment_info?.reference}</strong><br/>
                &nbsp;&nbsp;&nbsp;• Le numéro de transaction Mobile Money<br/>
                4. Activation sous 24-48h après vérification
              </div>
            </div>

            <button onClick={()=>setStep(4)} style={{width:"100%",background:C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:"pointer"}}>
              J'ai effectué le paiement ✓
            </button>
          </>
        )}

        {/* STEP 4 - CONFIRMATION */}
        {step===4 && (
          <>
            <div style={{textAlign:"center",padding:"40px 0"}}>
              <div style={{fontSize:60,marginBottom:16}}>🎉</div>
              <div style={{fontSize:24,fontWeight:700,color:C.accent,marginBottom:8}}>Demande envoyée !</div>
              <div style={{fontSize:14,color:C.muted,marginBottom:32,lineHeight:1.7}}>
                Votre demande de vérification est en cours de traitement.<br/>
                Le badge ✓ sera activé sous <strong style={{color:C.text}}>24 à 48 heures</strong> après confirmation du paiement.
              </div>
              <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:24,textAlign:"left"}}>
                <div style={{fontSize:13,fontWeight:700,marginBottom:12}}>Récapitulatif</div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <span style={{color:C.muted}}>Plan</span>
                  <span style={{fontWeight:700}}>{selectedPlan?.label}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <span style={{color:C.muted}}>Montant</span>
                  <span style={{fontWeight:700,color:C.accent}}>{selectedPlan?.price}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{color:C.muted}}>Référence</span>
                  <span style={{fontWeight:700,color:C.accent}}>{requestData?.payment_info?.reference}</span>
                </div>
              </div>
              <div style={{fontSize:13,color:C.muted,marginBottom:24}}>
                Pour toute question : <strong style={{color:C.text}}>+237 697 008 362</strong> (WhatsApp)
              </div>
              <button onClick={()=>navigate(-1)} style={{width:"100%",background:C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:"pointer"}}>
                Retour à PayChat
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
